import { InlineInputForm } from '@ui/general';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';

export interface ViewFormProps {
	currentName?: string;
	onCancel: () => void;
	onSubmit: (viewName: string) => void;
	processing?: boolean;
}

export const ViewForm: React.FC<ViewFormProps> = ({ currentName, ...rest }) =>
	<InlineInputForm
		cancelProps={ { id: currentName ? 'edit-view-cancel' : 'create-view-cancel' } }
		className='view-form'
		confirmProps={ {
			id: currentName ? 'edit-view-confirm' : 'create-view-confirm'
		} }
		currentValue={ currentName }
		inputProps={ {
			id: currentName ? 'edit-view-input' : 'create-view-input',
			placeholder: PLACEHOLDERS_COPY.NAME_YOUR_VIEW
		} }
		maxLength={ 55 }
		{ ...rest } />;

